import _objectSpread from "D:/work/admin/yujian_admin/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from "vuex";
import scroll from './mixins/normal';
export default {
  name: 'd2-container-full',
  mixins: [scroll],
  computed: _objectSpread({}, mapState("d2admin", {
    showDialog: function showDialog(state) {
      return state.method.showDialog;
    }
  })),
  created: function created() {},
  mounted: function mounted() {
    // 增加滚动事件监听
    this.addScrollListener();
  },
  beforeDestroy: function beforeDestroy() {
    // 移除滚动事件监听
    this.removeScrollListener();
  }
};